

import {
    LOGIN_DETAIL
} from '../actions/auth'

export function loginReducer(state = {
    detail: {
        role: ''
    }
}, action){
    switch(action.name){
        case LOGIN_DETAIL: 
            return Object.assign({}, state, {
                detail: action.data
            })
        default:
            return state;
    }    
}


// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js